/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Note_Rollback_SuccessInputs */

const vi_note_rollback_success = /** @type {(inputs: Note_Rollback_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã rollback, tạo phiếu điều chỉnh ${i?.code}`)
};

/**

* @param {Note_Rollback_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const note_rollback_success = /** @type {((inputs: Note_Rollback_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Note_Rollback_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_note_rollback_success(inputs)
});